import { ProfileBoxProps } from './profile.types';

export const ProfileBox: React.FC<ProfileBoxProps> = ({
    ...props
}) => {
    return (
        <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
            <div className="bg-brandPrimary-600 px-4 py-3">
                <span className="text-white text-sm font-semibold uppercase tracking-widest">Dati generali</span>
            </div>

            <div className="p-4 flex flex-col gap-3">
                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Regione</span>
                    <span className="text-sm font-medium text-neutral-700">{props.region || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">CUAA</span>
                    <span className="text-sm font-medium text-neutral-700">{props.CUAA || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">P. IVA</span>
                    <span className="text-sm font-medium text-neutral-700">{props.pIva || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Sede legale</span>
                    <span className="text-sm font-medium text-neutral-700">{props.sedeLegale || '-'}</span>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="flex justify-between gap-4 items-start text-left">
                    <span className="text-sm font-semibold text-brandPrimary-700">Recapito postale</span>
                    <span className="text-sm font-medium text-neutral-700">{props.recapitoPostale || '-'}</span>
                </div>
            </div>
        </div>
    );
}
